"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ArticleAuthors } from "../../partials/ArticleAuthors/ArticleAuthors";
import { ArticleBody } from "../../partials/ArticleBody/ArticleBody";
import { ArticleHeader } from "../../partials/ArticleHeader/ArticleHeader";
import { RelatedMatches } from "../../partials/RelatedMatches/RelatedMatches";
import { ArticleMatchDetail } from "../../partials/ArticleMatchDetail/ArticleMatchDetail";
import { useArticleData } from "../../context/ArticleDataContext";
import { SidebarContent } from "./SidebarContent";
import { AdSlot } from "@/features/ads/AdSlot";
import { DiscussionWidget } from "@/features/discussion/DiscussionWidget";
import { SectionStrip, type BrandedStyle } from "@/components/layout/SectionStrip";
import { ARTICLE_HERO, ARTICLE_RELATED } from "@/features/theme/sectionKeys";
import { useAuth } from "@/lib/auth/AuthContext";
interface ArticleLayoutDefaultWithSidebarProps {
  sectionStyles?: Record<string, BrandedStyle>;
  breadcrumbs?: React.ReactNode;
}
export function ArticleLayoutDefaultWithSidebar(t0) {
  const $ = _c(30);
  const {
    sectionStyles,
    breadcrumbs
  } = t0;
  const {
    post
  } = useArticleData();
  const {
    isAuthEnabled
  } = useAuth();
  const t1 = sectionStyles?.[ARTICLE_HERO];
  let t2;
  if ($[0] !== breadcrumbs) {
    t2 = breadcrumbs ? <div className="max-w-350 mx-auto px-4 pt-4">{breadcrumbs}</div> : null;
    $[0] = breadcrumbs;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArticleHeader variant="default" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2) {
    t4 = <SectionStrip brandedStyle={t1}>{t2}{t3}</SectionStrip>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AdSlot id="content-top" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <RelatedMatches showHeader={false} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== post.content) {
    t7 = <ArticleBody content={post.content} />;
    $[8] = post.content;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArticleMatchDetail />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== post.populatedAuthors) {
    t9 = <ArticleAuthors authors={post.populatedAuthors} />;
    $[11] = post.populatedAuthors;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isAuthEnabled || $[14] !== post.id || $[15] !== sectionStyles) {
    t10 = isAuthEnabled && <SectionStrip brandedStyle={sectionStyles?.[ARTICLE_RELATED]}><DiscussionWidget entityId={`post-${post.id}`} discussionLabel="Comments" className="mt-8" /></SectionStrip>;
    $[13] = isAuthEnabled;
    $[14] = post.id;
    $[15] = sectionStyles;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== t9) {
    t11 = <div className="flex-1 min-w-0 max-w-240">{t6}{t7}{t8}{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SidebarContent />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = <div className="flex flex-col md:flex-row gap-8">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <AdSlot id="content-bottom" />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13) {
    t15 = <div className="container mx-auto px-4 py-8 md:py-12 space-y-8">{t5}{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t4) {
    t16 = <article className="min-h-screen">{t4}{t15}</article>;
    $[27] = t15;
    $[28] = t4;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}